import { createAction } from '@reduxjs/toolkit';

import { getPayloadCreator } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';

import type { RegisterCreditProfilePayload } from '../credit-profile/types';
import type { CreditReport, CreditReportType } from './types';

const syncCreditReportPayloadCreator = getPayloadCreator<QcsSyncResourcesPayload<CreditReportType>>();
const errorPayloadCreator = getPayloadCreator<{ id?: string; message?: string }>();
const refreshCreditReportPayloadCreator = getPayloadCreator<RegisterCreditProfilePayload>();
const syncRefreshCreditReportPayloadCreator = getPayloadCreator<CreditReport>();

export const getCreditReport = createAction('GET_CREDIT_REPORT', getPayloadCreator());
export const getCreditReportSuccess = createAction('GET_CREDIT_REPORT_SUCCESS', syncCreditReportPayloadCreator);
export const getCreditReportFailure = createAction('GET_CREDIT_REPORT_FAILURE', errorPayloadCreator);

export const refreshCreditReport = createAction('REFRESH_CREDIT_REPORT', refreshCreditReportPayloadCreator);
export const refreshCreditReportSuccess = createAction(
  'REFRESH_CREDIT_REPORT_SUCCESS',
  syncRefreshCreditReportPayloadCreator,
);
export const refreshCreditReportFailure = createAction('REFRESH_CREDIT_REPORT_FAILURE', errorPayloadCreator);

export const getRefreshedCreditReport = createAction('GET_REFRESHED_CREDIT_REPORT', refreshCreditReportPayloadCreator);
export const getRefreshedCreditReportSuccess = createAction(
  'GET_REFRESHED_CREDIT_REPORT_SUCCESS',
  syncRefreshCreditReportPayloadCreator,
);
export const getRefreshedCreditReportFailure = createAction('GET_REFRESHED_CREDIT_REPORT_FAILURE', errorPayloadCreator);
